import React from 'react';
import Stack from '@mui/material/Stack';
import Avatar from '@mui/material/Avatar';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import Tooltip from '@mui/material/Tooltip';

const OwnerLogo = (props) => {
    return (
        <Stack direction="row" justifyContent="center" alignItems="center"  spacing={2}>
            {props.owner}
            <Avatar sx={{m:1,  width: 12, height: 12 }}>
                <Tooltip title={props.title}>
                    <AccountCircleIcon />
                </Tooltip>
            </Avatar>
        </Stack>  
    );
}

export default OwnerLogo;